import React from "react";

// --- Helper Component for Role Badges ---
const RoleBadge = ({ role }) => {
  let badgeStyle = styles.roleDefault;
  const r = role ? role.trim().toUpperCase() : "";

  if (r === 'PROJECT COORDINATOR') badgeStyle = styles.roleCoordinator;
  else if (r === 'MAKER') badgeStyle = styles.roleMaker;
  else if (r === 'CHECKER') badgeStyle = styles.roleChecker;
  else if (r === 'ISSUER') badgeStyle = styles.roleIssuer;
  else if (r === 'VENDOR') badgeStyle = styles.roleVendor;
  else if (r === 'OBSERVER') badgeStyle = styles.roleObserver;
  else if (r === 'ADMIN') badgeStyle = styles.roleAdmin;

  return (
    <span style={{ ...styles.badge, ...badgeStyle }}>
      {role}
    </span>
  );
};

const OverviewPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h3 style={styles.cardTitle}>Project Overview & Workflow</h3>
          </div>

          <div style={styles.cardBody}>
            <table style={styles.table}>
              {/* ✅ FIX: Removed comments/whitespace inside <tr> to prevent hydration errors */}
              <thead>
                <tr>
                  <th style={{ ...styles.th, width: "160px" }}>Step ID</th>
                  <th style={{ ...styles.th, width: "280px" }}>Role</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={styles.td}>1. User Registration</td>
                  <td style={styles.td}>
                    <RoleBadge role="PROJECT COORDINATOR" />
                  </td>
                  <td style={styles.td}>
                    • Onboard users - Maker(s), checker(s), Issuer, Vendor(s)<br />
                    • Notification is sent to User’s email with credentials
                  </td>
                </tr>

                <tr>
                  <td style={styles.td}>2. Create Project</td>
                  <td style={styles.td}>
                    <RoleBadge role="PROJECT COORDINATOR" />
                  </td>
                  <td style={styles.td}>
                    • The PROJECT_COORDINATOR enters the details of the Project and assigns registered actors to specific roles.<br />
                    • For Department, mapping Maker-Checker pairs need to be mapped<br />
                    • Notification email will be sent to the MAKERs
                  </td>
                </tr>

                <tr>
                  <td style={styles.td}>3. Upload Beneficiary List</td>
                  <td style={styles.td}>
                    <RoleBadge role="MAKER" />
                  </td>
                  <td style={styles.td}>
                    • The MAKER uploads the list of beneficiaries for the project. The format is an excel sheet.<br />
                    • A sample sheet can be downloaded from this page for reference.<br />
                    • Email Notification will be sent to the CHECKER of that Department.
                  </td>
                </tr>

                <tr>
                  <td style={styles.td}>4. Approve Beneficiary List</td>
                  <td style={styles.td}>
                    <RoleBadge role="CHECKER" />
                  </td>
                  <td style={styles.td}>
                    • Verify the beneficiary details and approve few or all of them
                  </td>
                </tr>

                <tr>
                  <td style={styles.td}>5. Issue voucher to beneficiary</td>
                  <td style={styles.td}>
                    <RoleBadge role="ISSUER" />
                  </td>
                  <td style={styles.td}>
                    • Validates the beneficiary list from all the departments, and the vendor list<br />
                    • Approve few or all of them and issue vouchers<br />
                    • Vouchers will be sent as SMS to the approved beneficiaries
                  </td>
                </tr>

                <tr>
                  <td style={styles.td}>6. Project Dashboard</td>
                  <td style={styles.td}>
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
                        <RoleBadge role="PROJECT COORDINATOR" />
                        <RoleBadge role="ADMIN" />
                        <RoleBadge role="OBSERVER" />
                    </div>
                  </td>
                  <td style={styles.td}>
                    • View the status of vouchers for the project<br />
                    • Observer such as company secretary banker ca and officials can use dashboard print reports for associated purpose such as payment to vendor , analytics and feedback and improvement
                  </td>
                </tr>

                <tr>
                  <td style={styles.td}>7. User Dashboard</td>
                  <td style={styles.td}>
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
                        <RoleBadge role="OBSERVER" />
                        <RoleBadge role="ADMIN" />
                    </div>
                  </td>
                  <td style={styles.td}>
                    • View the details of all the actors for the project
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: '#f0fdf9', // Teal Background
    fontFamily: "'Segoe UI', Roboto, sans-serif",
  },
  contentWrapper: {
    padding: '30px',
    flexGrow: 1,
    overflowY: 'auto',
  },
  card: {
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.04)",
    borderTop: "5px solid #20c997", // Teal Top Border
    maxWidth: "1100px",
    margin: "0 auto",
    overflow: "hidden",
  },
  cardHeader: {
    padding: "20px 30px",
    borderBottom: "1px solid #e1e4e8",
  },
  cardTitle: {
    margin: 0,
    fontSize: "1.3rem",
    color: "#2d3436",
    fontWeight: "700",
  },
  cardBody: {
    padding: "30px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
  },
  th: {
    backgroundColor: "#f8f9fa",
    borderBottom: "2px solid #e1e4e8",
    color: "#636e72",
    padding: "15px",
    fontWeight: "600",
    fontSize: "0.95rem",
    textAlign: "left",
  },
  td: {
    borderBottom: "1px solid #e1e4e8",
    padding: "15px",
    verticalAlign: "top",
    color: "#2d3436",
    wordWrap: "break-word",
    fontSize: "0.9rem",
    lineHeight: "1.6",
  },
  // Badge Styles
  badge: {
    padding: "4px 10px",
    borderRadius: "12px",
    fontSize: "0.75rem",
    fontWeight: "600",
    display: "inline-block",
    letterSpacing: "0.3px",
    border: "1px solid transparent",
  },
  // Specific Role Colors (Consistent with Dashboard)
  roleCoordinator: { backgroundColor: "#fff8e1", color: "#b45309", borderColor: "#fcd34d" },
  roleMaker: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#6ee7b7" },
  roleChecker: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#93c5fd" },
  roleIssuer: { backgroundColor: "#ecfeff", color: "#0e7490", borderColor: "#67e8f9" },
  roleVendor: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#c4b5fd" },
  roleObserver: { backgroundColor: "#fff7ed", color: "#c2410c", borderColor: "#fdba74" },
  roleAdmin: { backgroundColor: "#fef2f2", color: "#b91c1c", borderColor: "#fca5a5" },
  roleDefault: { backgroundColor: "#f3f4f6", color: "#374151", borderColor: "#e5e7eb" },
};

export default OverviewPage;